import React from 'react';

const Contact = () => {
  return (
    <div className="contact-page">
      <div className="page-header">
        <div className="container">
          <h1>Contact Us</h1>
          <p>Get in touch with us</p>
        </div>
      </div>
      <div className="container section">
        <p>Contact page - To be implemented</p>
      </div>
    </div>
  );
};

export default Contact;
